import { GcpBox, GcpTypography } from '@back-office/ui';
import { Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TransactionTransferProps, useStyles } from './shared';

const TransferDesktopView: FC<TransactionTransferProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { payerName, merchantBusinessType, mid, sourceOfFund, tid, fundsUID } =
    props;

  return (
    <GcpBox mb={3} mt={6} pb={3} pl={3}>
      <Grid container className={classes.wrap} spacing={2}>
        <Grid item xs={3}>
          {t('transaction_list.name')}
        </Grid>
        <Grid item className={classes.belowGrid} xs={3}>
          <GcpTypography paint="hitGray" variant="body1">
            {payerName || '-'}
          </GcpTypography>
        </Grid>
        <Grid item xs={3}>
          <GcpTypography className={classes.secondColumn} variant="body1">
            {t('transaction_list.mid')}
          </GcpTypography>
        </Grid>
        <Grid item xs={3}>
          <GcpTypography paint="hitGray" variant="body1">
            {mid || '-'}
          </GcpTypography>
        </Grid>
        <Grid item xs={3}>
          {t('transaction_list.wallet_id')}
        </Grid>
        <Grid item className={classes.belowGrid} lg={3} xs={8}>
          <GcpTypography paint="hitGray" variant="body1" wordBreak="break-all">
            {fundsUID || '-'}
          </GcpTypography>
        </Grid>
        <Grid item xs={3}>
          <GcpTypography className={classes.secondColumn} variant="body1">
            {t('transaction_list.mcc')}
          </GcpTypography>
        </Grid>
        <Grid item xs={3}>
          <GcpTypography paint="hitGray" variant="body1">
            {merchantBusinessType || '-'}
          </GcpTypography>
        </Grid>
        <Grid item xs={3}>
          <GcpBox>{t('transaction_list.source')}</GcpBox>
        </Grid>
        <Grid item className={classes.belowGrid} xs={3}>
          <GcpTypography paint="hitGray" variant="body1">
            {sourceOfFund || '-'}
          </GcpTypography>
        </Grid>
        <Grid item xs={3}>
          <GcpTypography className={classes.secondColumn} variant="body1">
            {t('transaction_list.tid')}
          </GcpTypography>
        </Grid>
        <Grid item xs={3}>
          <GcpTypography paint="hitGray" variant="body1">
            {tid || '-'}
          </GcpTypography>
        </Grid>
      </Grid>
    </GcpBox>
  );
};

export default TransferDesktopView;
